import get from 'lodash/fp/get';
import set from 'lodash/fp/set';
import keyBy from 'lodash/fp/keyBy';
import landingPageTypePathTypeMap from 'config/types/landingPage';
import getMatch from 'selectors/getMatch';
import { LANDING } from 'config/types/content';
import { LOCATION_CHANGE } from 'connected-react-router';
import { RECEIVE_PRIMARY_CONTENT } from 'config/types/action';

/**
 * State container reducer for landing page related actions.
 * @param {object}  state   state container
 * @param {string}  type
 * @param {*}       payload
 * @return {object}
 */
export default function landingPageReducer(state, { type, payload }) {
  const { params, pathType } = getMatch(state);
  const landingPageType = landingPageTypePathTypeMap[pathType];
  let currentLanding = null;

  const getCurrentLanding = (landingPages) => (
    Object.keys(landingPages).find((id) => {
      const landingPage = landingPages[id];
      return landingPageType === get('metadata.landingPageType', landingPage) &&
        // This is a babbel-specific parameter
        params.language === get('metadata.language', landingPage);
    })
  );

  switch (type) {
    case RECEIVE_PRIMARY_CONTENT:
      currentLanding = getCurrentLanding(
        keyBy('id', get(LANDING, payload)) || [],
      );
      break;

    case LOCATION_CHANGE:
      currentLanding = getCurrentLanding(
        get(`contentItem.${LANDING}.byId`, state) || [],
      );
      break;

    default:
      currentLanding = state.landingPage;
      break;
  }

  return set('landingPage', parseInt(currentLanding, 10), state);
}
